<template>
    <sidebar-layout
        :moduleCode="moduleCode"
        :subModuleCode="subModuleCode"
        :containerClasses="containerClasses"
        :enableHeader="enableHeader"
        :enableFooter="enableFooter"
        :navTopMenu="hasNavTopMenu"
        :enableMainSidebar="enableMainSidebar"
        :mainSidebarOnlyMobile="mainSidebarOnlyMobile"
        :fixedTopMenuDashboard="fixedTopMenuDashboard"
        >

        <template v-if="!hasNavTopMenu" v-slot:aside-main-menu>
            <nav-menu-sidebar />
        </template>

        <template v-slot:content-top>
            <slot name="content-top"></slot>
        </template>

        <template v-slot:main>
            <slot name="main"></slot>
        </template>

        <template v-slot:aside-control>
            <slot name="aside-control"></slot>
            <transition name="fade">
                <panel-dashboard
                    v-if="activeDashboardPanel"
                    :moduleCode="moduleCode"
                    data-panel="dashboard"
                    panelTitle="Dashboard"
                    position="right"
                    size="small"
                >
                </panel-dashboard>
            </transition>
        </template>
        <template v-slot:bottom-control>
            <swipe-menu-map
                v-if="swipeMenu"
                :moduleCode="moduleCode"
            />
        </template>
    </sidebar-layout>
</template>

<script>
    import GlobalMixin from '@/app/shared/mixins/global';
    import NavMenuSidebar from '@modules/portal/elements/NavMenuSidebar.vue';
    import SwipeMenuMap from '@/app/shared/components/menu/SwipeMenuMap.vue';

    export default {
        mixins: [
            GlobalMixin,
        ],
        props: {
            moduleCode: {
                type: String,
                require: true,
                default: null
            },
            subModuleCode: {
                type: String,
                require: false,
                default: null
            },
            containerClasses: {
                type: String,
                default: 'only-map'
            },
            mainSidebarOnlyMobile: {
                type: Boolean,
                default: true
            },
            fixedTopMenuDashboard: {
                type: Boolean,
                default: false
            },
            enableHeader: {
                type: Boolean,
                default: true
            },
            enableFooter: {
                type: Boolean,
                default: true
            },
            enableMainSidebar: {
                type: Boolean,
                default: true
            },
            navTopMenu: {
                type: Boolean,
                default: true
            },
            swipeMenu: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
                idPanelDashboard: 'dashboard',
            }
        },
        components: {
            SwipeMenuMap,
            NavMenuSidebar,
            PanelDashboard: () => import(/* webpackChunkName: "panel-dashboard" */ '@/app/shared/components/common/PanelDashboard'),
        },
        computed: {
            getStateTool(){
                return  this.moduleCode ? this.$store.getters.getStateTool : null;
            },
            hasNavTopMenu: function() {
                return this.navTopMenu && this.layoutConf.navigation.navTopMenu;
            },
            activeDashboardPanel() {
                return typeof this.getStateTool === 'function' ? (this.checkPermissionPanel(this.getStateTool(this.moduleCode, this.idPanelDashboard), this.idPanelDashboard)  && !this.hasNavTopMenu) : false;
            },
        },
    }
</script>
